import { render, staticRenderFns } from "./TaskSelectView.vue?vue&type=template&id=64f249fe&scoped=true&"
import script from "./TaskSelectView.vue?vue&type=script&lang=js&"
export * from "./TaskSelectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f249fe",
  null
  
)

export default component.exports